<template>
    <div class="user-navigation-items justify-content-end gap-3 gap-sm-4 d-flex flex-nowrap flex-row flex-grow">
        <back-to-button v-if="showBackToCollectionLink"></back-to-button>
        <router-link to="/dashboard" v-if="showDashboard">
            <i class="fa fa-pie-chart"/><span class="d-none d-md-inline">&nbsp;</span>
            <span class="d-none d-md-inline">Dashboard</span>
        </router-link>
        <suggestions-global-navigation v-if="showContentWorkflow"></suggestions-global-navigation>
        <nav-accounts v-show="showAccountsMenu" style="max-width: calc(100vw - 5em - 4rem);"/>
    </div>
</template>

<script>
import NavAccounts from '@/components/Navigation/AccountsDropdown'
import NavRssFeed from "@/components/Navigation/RSSLink"
import NavSuggestionsManager from "@/components/Navigation/SuggestionsManager"
import {mapGetters, mapActions} from 'vuex';
import RouteContext from '@/utilities/RouteContext'
import SuggestionsGlobalNavigation from "@/components/Navigation/V2/SuggestionsGlobalNavigation";
import BackToButton from "@/components/Suggestions/ManageSuggestion/BackToButton.vue";

export default {
    replace: false,
    mixins: [RouteContext],
    props: ['topic', 'isNonFreeAccount'],
    components: {
        BackToButton,
        SuggestionsGlobalNavigation,
        NavAccounts,
        NavRssFeed,
        NavSuggestionsManager
    },
    computed: {
        ...mapGetters({
            showingNotes: 'showAccountNotesReader',
            suggestionViewerType: "suggestionViewerType",
            hasSuggestions: 'hasSuggestions',
            accountFeatures: 'accountFeatures',
        }),
        showBackToCollectionLink() {
            console.log('showBackToCollectionLink', this.navMode, this.navFull, this.$route.name, this.hasSuggestions && this.hasSuggestions.id)
            return this.navFull &&  this.$route.name !== 'Suggestions' && this.hasSuggestions && this.hasSuggestions.id;
        },
        showDashboard() {
            return this.navFull &&  this.$route.name !== 'Dashboard';
        },
    },
    methods: {
        ...mapActions({
            toggleNotes: 'toggleAccountNotesReader'
        }),
    }
}
</script>
